module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/226-united-states-95cf2213edb5e4abbf942d71638d6f09.svg";